export default __webpack_public_path__ + "static/media/padelplayer_11zon.4859240b.png";